module.exports = __webpack_public_path__ + "img/HA1509-76.723c1fa2.jpg";